// extracted by mini-css-extract-plugin
module.exports = {"p":"styles_p__OqmIO","h1":"styles_h1__ZXQ9c","h2":"styles_h2__KtOGn","h3":"styles_h3__iZae_","h4":"styles_h4__X7FcM"};